import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { HTTP_BYPASS_INTERCEPTOR } from 'src/app/components/common/http-mgmt/http-mgmt.module';
import { SelecionadoHistoricoBeneficiario } from '../../core/selecionado-historico-beneficiario';


const rootPath = 'api/relatoriobeneficiario/';

@Injectable({
  providedIn: 'root'
})
export class RelatorioBeneficiarioService {

  constructor(private http: HttpClient, 
             @Inject(HTTP_BYPASS_INTERCEPTOR) private httpBypassInterceptor: HttpClient) { 

  }

  showRelatorio(tipoRelatorio, mimetype, listaIdsAluno:any[]): any {
    return this.http.post(`${rootPath}mimetype/${mimetype}/tipo/${tipoRelatorio}`, listaIdsAluno , {responseType: 'arraybuffer'});
  }

  showRelatorioHistorico(tipoPedagogicoSelecionado, tipoPsicossocialSelecionado, mimetype, listaSelecionados: SelecionadoHistoricoBeneficiario[], dataInicioEntradaInstituicao: any, dataFimEntradaInstituicao: any): any {

    const p_dataInicioEntradaInstituicao = dataInicioEntradaInstituicao 
        ? dataInicioEntradaInstituicao.getTime() 
        : '';

    const p_dataFimEntradaInstituicao = dataFimEntradaInstituicao 
        ? dataFimEntradaInstituicao.getTime() 
        : '';

    const params: any = {
        dataInicioEntradaInstituicao: `${p_dataInicioEntradaInstituicao}`,
        dataFimEntradaInstituicao: `${p_dataFimEntradaInstituicao}`,
        tipoPedagogicoSelecionado: `${tipoPedagogicoSelecionado}`,
        tipoPsicossocialSelecionado: `${tipoPsicossocialSelecionado}`
    };

    return this.http.post(`${rootPath}historico/mimetype/${mimetype}/tipo`, listaSelecionados, 
        {
            responseType: 'arraybuffer',
            params
        }
    );
  }

}